import axios from "axios";
import _ from "lodash";
import ServiceApi from "./service.api";

const env = process.env;
const TafrihanServiceApi = axios.create({
  timeout: 120000,
  baseURL: `${env.REACT_APP_PHOTOPATH_WEB}/api/v1`
})

TafrihanServiceApi.interceptors.request.use(
  async (config) => {
    config.headers = {
      "X-API-TOKEN": await ServiceApi.get("/api/v1/Home/getEncryptedId")
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

TafrihanServiceApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    return Promise.reject(ServiceApi.getErrorText(error));
  },
);

export default TafrihanServiceApi;
